import React from "react";
import "./Aboutproduk.scss";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import cgb from "../../Media/FotoAbout.webp";
const rumah = () => {
  return (
    <div id="jgc" className="rumahjasmia">
      <h1>Welcome to Jakarta Garden City</h1>
      <h2>Cicilan Start From 4 Juta/Bulan</h2>
      <div className="herojasmia">
        <img className="fotohome" src={cgb} alt={cgb} />
        <div className="desk-jasmia">
          Selamat Datang di Jakarta Garden City, Hunian hunian modern, nyaman,
          dan berkelas yang memiliki berbagai macam tipe. Jakarta Garden City
          Menawarkan Cluster Vastu, Cluster Essence, Cluster Mahakam memiliki 5
          Sebagai salah satu kawasan hunian premium, Jakarta Garden City
          menyediakan berbagai fasilitas yang menunjang kehidupan sehari-hari
          penghuni seperti Clubhouse, Children Playground, Basketball Court,
          Swimming pool. Serta untuk meningkatkan sistem keamanan Jakarta Garden
          City menyediakan Security 24 Hours dan One Gate System.
        </div>
      </div>
    </div>
  );
};

export default rumah;
